export default {
    'SET_TICKETS'(state, tickets){
        state.tickets = tickets
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/zendesk/mutations.js